import {Component, HostBinding, Input} from '@angular/core';

type ProgressSize = 'sm' | 'md' | 'lg';
type ProgressColor = 'primary' | 'success' | 'warning' | 'danger' | 'neutral';

@Component({
  selector: 'app-shared-progress-bar',
  templateUrl: './shared-progress-bar.component.html',
  styleUrls: ['./shared-progress-bar.component.scss'],
  standalone: false,
})
export class SharedProgressBarComponent {
  @Input() current = 0;
  @Input() total: number | null = 100;
  @Input() label?: string;
  @Input() showFraction = true;
  @Input() showPercent = true;
  @Input() size: ProgressSize = 'md';
  @Input() color: ProgressColor = 'primary';

  @HostBinding('class') get hostClass(): string {
    return `progress-host size-${this.size} color-${this.color}`;
  }

  get isIndeterminate(): boolean {
    return this.total == null || this.total === 0;
  }

  get percent(): number {
    if (this.isIndeterminate) return 0;
    const t = Math.max(1, this.total);
    return Math.max(0, Math.min(100, Math.round((this.current / t) * 100)));
  }

  get fractionText(): string {
    if (this.isIndeterminate) return '';
    return `${this.current} / ${this.total}`;
  }

  get ariaLabel(): string {
    const parts: string[] = [];
    if (this.label) parts.push(this.label);
    if (!this.isIndeterminate && this.showPercent) parts.push(`${this.percent}%`);
    if (!this.isIndeterminate && this.showFraction) parts.push(this.fractionText);
    return parts.join(': ') || 'Progress';
  }
}
